import { Component } from 'react'
import AWSAPI from '../../../../../common/AWSAPI'
import Window from '../../../../../common/Window'
import sprintf from 'sprintf'
import Prefecture from '../../../../../common/Prefecture'
import Config from '../../../../../Config'

class DefaultSettingManagement extends Component {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false}
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  componentWillMount () {
    this.loadDefaultSetting()
  }
  loadDefaultSetting () {
    const onSuccess = (res) => {
      const defaulSetting = res.body.data.systemSettingValue
      this.setState({
        isLoaded: true,
        [this.systemSettingName]: defaulSetting,
        // 入力input用（defaulSettingは数値でないといけないが、「0.」と入力した場合「0」と変換されてしまうため）
        [this.systemSettingName + 'InputData']: JSON.parse(JSON.stringify(defaulSetting))
      })
    }
    const params = {
      command: 'get',
      systemSettingName: this.systemSettingName
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  getSettingData () {
    return this.state[this.systemSettingName]
  }
  onSubmit (e) {
    e.preventDefault()
    Window.confirm('この内容で更新してよろしいですか?', () => {
      const DefaulSetting = this.state[this.systemSettingName]
      const paramsToSet = {
        command: 'set',
        systemSettingName: this.systemSettingName,
        systemSettingValue: DefaulSetting
      }
      const onSuccessToPost = (res) => {
        Window.alert('保存しました')
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    })
  }
  getPrefectureList () {
    return Prefecture
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  getIntYM () {
    const nowDate = new Date()
    return nowDate.getFullYear() * 100 + nowDate.getMonth() + 1
  }
  getYMList (plusYear = 0, minYM = 201603, format = '%s年%s月分(%s年%s月納付)') {
    const now = new Date()
    let year = Number(now.getFullYear()) + Number(plusYear)
    let month = now.getMonth() + 1
    const yearMonthList = []
    while (year * 100 + month >= minYM) {
      let nextYear = year
      let nextMonth = month + 1
      if (nextMonth === 13) {
        nextYear++
        nextMonth = 1
      }
      yearMonthList.push({
        id: year * 100 + month,
        name: sprintf(format, year, month, nextYear, nextMonth)
      })
      month--
      if (month === 0) {
        year--
        month = 12
      }
    }
    return yearMonthList
  }
}
export default DefaultSettingManagement



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/abstract/DefaultSettingManagement.js